import React from "react";
//Components
import Header from "./components/Header/Header";
import Footer from "components/Footer/Footer";
import Product from "./Pages/Product/Product";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import ProductSearchResult from "./Pages/ProductSearchResult/ProductSearchResult";
import CategoryProducts from "Pages/CategoryProducts/CategoryProducts";
import ReservationPage from "./Pages/ReservationPage/ReservationPage";
import SuccessfulReservation from "./Pages/SuccessfulReservation/SuccessfulReservation";
import SignupPage from "./Pages/SignupPage/SignupPage";
import SuccessfulCreation from "./Pages/SuccessfulCreation/SuccessfulCreation";

//Router
import { BrowserRouter, Switch, Route } from "react-router-dom";

//Styles
import "./styles/styles.scss";
//Context
import UserContext from "context/UserContext";
import GuardedRoute from "GuardedRoute";
import NewProduct from "Pages/NewProduct/NewProduct";
import UserReservations from "Pages/UserReservations/UserReservations";

function App() {
  return (
    <>
      <UserContext>
        <BrowserRouter>
          <Header />

          <Switch>
            <Route exact path="/home" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={SignupPage} />
            <Route exact path="/product/:id" component={Product} />
            <Route exact path="/city/:city" component={ProductSearchResult} />
            <Route
              path="/dates/:startDate/:endDate"
              component={ProductSearchResult}
            />
            <Route
              path="/city/:city/dates/:startDate/:endDate"
              component={ProductSearchResult}
            />
            <Route path="/category/:category" component={CategoryProducts} />
            <GuardedRoute
              exact
              path="/product/:id/reservation"
              component={ReservationPage}
            />
            <GuardedRoute
              path="/reservation/success"
              component={SuccessfulReservation}
            />
            <GuardedRoute
              path="/admin/product/success"
              component={SuccessfulCreation}
            />
            <GuardedRoute
              path="/user/reservations"
              component={UserReservations}
            />
            ""
            <Route exact path="/admin/product" component={NewProduct} />
            <Route index component={Home} />
          </Switch>
          <Footer />
        </BrowserRouter>
      </UserContext>
    </>
  );
}

export default App;
